import * as React from 'react';
import { EStarSize, EStarTheme } from '../../types/star';
import { getPrettyFloat } from '../../utils';
import { Star } from '../Star';
import { Stars } from '../Stars';
import { NoRating } from './NoRating';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MobileRatingComponent(_ref) {
  var value = _ref.value,
    _short = _ref.short,
    reviewCount = _ref.reviewCount,
    withRatingValue = _ref.withRatingValue;
  if (!value) {
    return /*#__PURE__*/_jsx(NoRating, {});
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("div", {
      "data-testid": "rating",
      className: styles['rating'],
      itemProp: withRatingValue ? 'ratingValue' : undefined,
      children: getPrettyFloat(value)
    }), reviewCount !== undefined && /*#__PURE__*/_jsx("span", {
      "data-testid": "reviewCount",
      itemProp: "reviewCount",
      className: styles['invisible'],
      children: reviewCount
    }), /*#__PURE__*/_jsx("div", {
      className: styles['stars'],
      children: _short ? /*#__PURE__*/_jsx(Star, {
        theme: EStarTheme.Filled,
        size: EStarSize.M
      }) : /*#__PURE__*/_jsx(Stars, {
        value: value,
        size: EStarSize.M
      })
    })]
  });
}
export var MobileRating = /*#__PURE__*/React.memo(MobileRatingComponent);